import React from 'react';
import { connect } from 'react-redux';
import HTMLReport from '../components/HTMLReport/HTMLReport';
import Breadcrumb from '../components/Common/Breadcrumb';

const Report = () => {
  return (
    <React.Fragment>
      <Breadcrumb items={[{ label: 'Reports', link: '/reports' }]} />

      <HTMLReport />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Report);
